var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewSponsor } from "./view";
import LocalStorageService from "../../services/localStorage";
import { patchSponsorClearData, postSponsorClearData, } from "../../store/sponsor/actions";
import { clearDataPutAvatar, putAvatar } from "../../store/avatar/actions";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { useSponsorGetAll } from "../../fnx/sponsor/sponsorGetAll";
import { useSponsorCreate } from "../../fnx/sponsor/sponsorCreate";
import { useSponsorPatch } from "../../fnx/sponsor/sponsorPatch";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { sponsorDataForm } from "./sponsorDTO";
import { hasPermission } from "../../services/getNavigationPages";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var SponsorAdmin = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(1), pageSponsor = _a[0], setPageSponsor = _a[1];
    var _b = useState(20), sponsorLimit = _b[0], setSponsorLimit = _b[1];
    var _c = useState(0), countPaginationSponsor = _c[0], setCountPaginationSponsor = _c[1];
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(false), triggerPost = _e[0], setTriggerPost = _e[1];
    var _f = useState(false), triggerPatch = _f[0], setTriggerPatch = _f[1];
    var _g = useState([]), sponsorList = _g[0], setSponsorList = _g[1];
    var _h = useState(false), openModal = _h[0], setOpenModal = _h[1];
    var _j = useState(false), openModalDelete = _j[0], setOpenModalDelete = _j[1];
    var _k = useState(false), openModalCloneConfirm = _k[0], setOpenModalCloneConfirm = _k[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _l = useState(null), avatarFile = _l[0], setAvatarFile = _l[1];
    var _m = useState(false), isUpdate = _m[0], setIsUpdate = _m[1];
    var _o = useState(false), openDrawer = _o[0], setOpenDrawer = _o[1];
    var _p = useState(""), titleDrawer = _p[0], setTitleDrawer = _p[1];
    var _q = useState(null), itemModal = _q[0], setitemModal = _q[1];
    var _r = useState(""), nameSearch = _r[0], setNameSearch = _r[1];
    var _s = useState(), bodyRequest = _s[0], setBodyRequest = _s[1];
    var _t = useState(sponsorDataForm), dataForm = _t[0], setDataForm = _t[1];
    var _u = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _u[0], setSeeToast = _u[1];
    var _v = useSponsorGetAll(trigger, clientId, nameSearch, pageSponsor, sponsorLimit), responseSponsor = _v.responseSponsor, errorSponsor = _v.errorSponsor, loadingSponsor = _v.loadingSponsor;
    var _w = useSponsorCreate(triggerPost, bodyRequest), responsePostSponsor = _w.responsePostSponsor, errorPostSponsor = _w.errorPostSponsor, loadingPostSponsor = _w.loadingPostSponsor;
    var _x = useSponsorPatch(triggerPatch, bodyRequest), responsePatchSponsor = _x.responsePatchSponsor, errorPatchSponsor = _x.errorPatchSponsor, loadingPatchSponsor = _x.loadingPatchSponsor;
    var _y = useSelector(function (state) { return ({
        responsePutAvatar: state.Avatar.responsePutAvatar,
        errorPutAvatar: state.Avatar.errorPutAvatar,
        loadingPutAvatar: state.Avatar.loadingPutAvatar,
    }); }), responsePutAvatar = _y.responsePutAvatar, errorPutAvatar = _y.errorPutAvatar, loadingPutAvatar = _y.loadingPutAvatar;
    var _z = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _z.responseDeleteEntity, loadingDeleteEntity = _z.loadingDeleteEntity, errorDeleteEntity = _z.errorDeleteEntity;
    useEffect(function () {
        if (!(responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.data)) {
            setTrigger(true);
        }
    }, []);
    useEffect(function () {
        if (responseSponsor && (responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.data)) {
            var newSponsorList = responseSponsor.data.map(function (item) { return ({
                id: item.id,
                title: item.name,
                code: item.code,
                logo: item.logoUrl,
                clientId: item.clientId,
            }); });
            setSponsorList(newSponsorList);
            setTrigger(false);
        }
        if (responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.pagingInfo) {
            setCountPaginationSponsor(responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.pagingInfo.totalItems);
        }
    }, [responseSponsor]);
    useEffect(function () {
        if (responsePostSponsor && (responsePostSponsor === null || responsePostSponsor === void 0 ? void 0 : responsePostSponsor.data)) {
            showToastSuccessMessage("Patrocinador creado con éxito.", typeAlert.success, setSeeToast);
            setTrigger(true);
            dispatch(postSponsorClearData());
            dispatch(putAvatar("Sponsor", responsePostSponsor.data.id, avatarFile));
            setAvatarFile(null);
            setTriggerPost(false);
        }
        else if (errorPostSponsor) {
            showErrorToast(errorPostSponsor, setSeeToast, t);
            setTriggerPost(false);
        }
    }, [responsePostSponsor, errorPostSponsor]);
    useEffect(function () {
        if (responsePutAvatar && (responsePutAvatar === null || responsePutAvatar === void 0 ? void 0 : responsePutAvatar.url)) {
            showToastSuccessMessage("Patrocinador actualizado con éxito.", typeAlert.success, setSeeToast);
            dispatch(clearDataPutAvatar());
            setOpenModal(false);
            setTrigger(true);
        }
    }, [responsePutAvatar]);
    useEffect(function () {
        if (errorPutAvatar) {
            showErrorToast(errorPutAvatar, setSeeToast, t);
        }
    }, [errorPutAvatar]);
    useEffect(function () {
        if (responseDeleteEntity) {
            showToastSuccessMessage("Patrocinador eliminado con éxito.", typeAlert.success, setSeeToast);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (responsePatchSponsor && responsePatchSponsor.data) {
            setOpenDrawer(false);
            if (avatarFile != null) {
                dispatch(putAvatar("Sponsor", responsePatchSponsor.data.id, avatarFile));
                setAvatarFile(null);
            }
            else {
                showToastSuccessMessage("Patrocinador actualizado con éxito.", typeAlert.success, setSeeToast);
            }
            setTrigger(true);
            setTriggerPatch(false);
            dispatch(patchSponsorClearData());
        }
        else if (errorPatchSponsor) {
            showErrorToast(errorPatchSponsor, setSeeToast, t);
            setTriggerPatch(false);
        }
    }, [responsePatchSponsor, errorPatchSponsor]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    useEffect(function () {
        if (nameSearch) {
            setTrigger(true);
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var filterStatus = function (item) {
        var idSponsor = item === null || item === void 0 ? void 0 : item.sponsor.map(function (item) { return item.id; }).join(",");
        setTrigger(true);
    };
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { id: row.id, SponsorName: row.title, Code: row.code, clientId: row.clientId }));
    };
    var permissions = {
        create: hasPermission("admin-sponsor-create"),
        edit: hasPermission("admin-sponsor-edit"),
        delete: hasPermission("admin-sponsor-delete"),
    };
    var handleSubmitSponsor = function (dataSponsor, file) {
        if (isUpdate) {
            setBodyRequest({
                id: dataSponsor.id,
                clientId: dataSponsor.clientId,
                name: dataSponsor.SponsorName,
                code: dataSponsor.Code,
            });
            setTriggerPatch(true);
            setAvatarFile(file);
        }
        else {
            setBodyRequest({
                name: dataSponsor.SponsorName,
                code: dataSponsor.Code,
            });
            setDataForm(sponsorDataForm);
            setOpenDrawer(false);
            setTriggerPost(true);
            setAvatarFile(file);
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setDataForm({
            SponsorName: "",
            Code: "",
            Img: "",
        });
        setTitleDrawer("Agregar patrocinador");
        setIsUpdate(false);
        setOpenDrawer(true);
    };
    var onClickContextMenu = function (opt, item) {
        switch (opt.id) {
            case "1":
                setIsUpdate(true);
                setTitleDrawer("Modificar patrocinador");
                setOpenDrawer(true);
                showEdit(item);
                break;
            case "2":
                setOpenModalDelete(true);
                setitemModal(item);
                break;
            case "3":
                setitemModal(item);
                setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    var handleDelete = function () {
        setOpenModalDelete(false);
        dispatch(deleteEntity({
            id: itemModal.id,
            entity: "SponsorEntity",
            idUser: clientId,
        }));
    };
    var handleClone = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
        dispatch(postSponsorClearData());
        setAvatarFile(itemModal.logo);
    };
    var onCloseDrawer = function () {
        setDataForm({
            SponsorName: "",
            Code: "",
            Img: "",
        });
        setOpenDrawer(false);
        setTitleDrawer("");
    };
    var onChangeRowsPerPage = function (e) {
        setSponsorLimit(e);
        setTrigger(true);
    };
    var onChangePage = function (e) {
        setPageSponsor(e);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingSponsor ||
                    loadingPostSponsor ||
                    loadingPatchSponsor ||
                    loadingDeleteEntity ||
                    loadingPutAvatar, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: loadingDeleteEntity ? "Eliminando sponsor" : "Cargando sponsor..." }), _jsx(ViewSponsor, { permissions: permissions, loadingPostSponsor: loadingPostSponsor, sponsorList: sponsorList, openModal: openModal, openModalCloneConfirm: openModalCloneConfirm, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, onClickContextMenu: onClickContextMenu, onCloseSearch: onCloseSearch, searchFilter: searchFilter, filterStatus: filterStatus, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onSaveData: handleSubmitSponsor, onClickAdd: handleOnClickAdd, editMode: isUpdate, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, onCloseDrawer: onCloseDrawer, pageSponsor: pageSponsor, sponsorLimit: sponsorLimit, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, countPaginationSponsor: countPaginationSponsor, titleDrawer: titleDrawer })] }));
};
export default SponsorAdmin;
